<div class="card">
    <p-megaMenu [model]="items" styleClass="admin-mega-menu" />
</div>
